/* eslint-disable @typescript-eslint/no-explicit-any */
import { useGetStoresOptionsQuery } from "@/services/store/select-options";
import { useFilterActions } from "@/pages/conciliation/stores/ducks/filter/hooks/actions";
import SingleSelect from "components/input-select-store";

export default function StoreFilter() {
  const { updateFilter } = useFilterActions();
  const { data: storeOptions } = useGetStoresOptionsQuery();

  const handleSelectStoreChange = (
    option: { value: string; label: string } | undefined
  ) => {

    if (option) {
      updateFilter({ key: "code", value: option.value });
      updateFilter({ key: "meta", value: { page: 1 } });
    }
  };
  
  return (
    <SingleSelect
      label="Loja"
      options={storeOptions || []}
      placeholder="Selecionar loja"
      onChange={handleSelectStoreChange}
    />
  );
}
